<template>
  <transition name="fade" mode="out-in">
    <div class="full-loader" v-if="visible">
      <!--<span></span>-->
      <loader-spinner/>
      <p class="loader-text">{{text}}</p>
    </div>
  </transition>
</template>

<script>
import loaderPlugin from './loader/base-full-loader-plugin'
import LoaderSpinner from '@/components/base/loader/loader-spinner'

const DEFAULT_TEXT = ' '

export default {
  name: 'base-full-loader',
  components: { LoaderSpinner },
  data () {
    return {
      visible: false,
      text: DEFAULT_TEXT
    }
  },
  methods: {
    show (params) {
      this.visible = true
      this.text = params || DEFAULT_TEXT
    },
    hide () {
      this.visible = false
    }
  },
  beforeMount () {
    loaderPlugin.EventBus
      .$on('show', (params) => {
        this.show(params)
      })
      .$on('hide', () => {
        this.hide()
      })
  }
}
</script>

<style scoped lang="scss" src="./base-comp-styles/base-full-loader.scss"></style>
